export enum ActionRequiredPopoverActionEnum {
  SELECT_INVITES = 'SELECT_INVITES',
  SELECT_ONE = 'SELECT_ONE',
  REVIEW_INVITE = 'REVIEW_INVITE',
  REVIEW_INVITES = 'REVIEW_INVITES',
}
